import { api } from './api';
import type {
  BoxAnswerRequest,
  BoxConfigurationResponse,
  BoxConfigurationsResponse,
  BoxMenu,
  BoxPackagesResponse,
  BoxSummary,
  MeBoxesResponse,
  UnionOptionsResponse,
} from '@/types';

/**
 * API della sezione "Box auto" (sezione originale creata da spec, non presente nel legacy).
 * Auth = stub `x-user-email` come il resto. Il totale è sempre l'extra sul capitolato (capitolato=0).
 */
export const boxApi = {
  /** Box dell'utente; se ≥1 si mostra la card d'ingresso "Box auto". */
  getMyBoxes: (): Promise<MeBoxesResponse> =>
    api.get<MeBoxesResponse>('/api/me/boxes').then((r) => r.data),

  /** Configurazioni box (max 4, una copre tutti i box del progetto), con progress 0–100. */
  getConfigurations: (): Promise<BoxConfigurationsResponse> =>
    api.get<BoxConfigurationsResponse>('/api/box/configurations').then((r) => r.data),

  createConfiguration: (name?: string): Promise<BoxConfigurationResponse> =>
    api
      .post<BoxConfigurationResponse>('/api/box/configurations', name != null ? { name } : {})
      .then((r) => r.data),

  renameConfiguration: (id: number, name: string): Promise<BoxConfigurationResponse> =>
    api
      .patch<BoxConfigurationResponse>(`/api/box/configurations/${id}`, { name })
      .then((r) => r.data),

  deleteConfiguration: (id: number): Promise<void> =>
    api.delete(`/api/box/configurations/${id}`).then(() => undefined),

  /** Menu box-major: eventuale voce UNIONE + per ogni box BASCULANTE e RICARICAAUTO. */
  getMenu: (id: number): Promise<BoxMenu> =>
    api.get<BoxMenu>(`/api/box/configurations/${id}/menu`).then((r) => r.data),

  /** Pacchetti di un substep (basculante/ricarica) per un box, già filtrati per tipologia. */
  getPackages: (substepId: number, boxId: number): Promise<BoxPackagesResponse> =>
    api
      .get<BoxPackagesResponse>(`/api/box/substeps/${substepId}/packages`, { params: { boxId } })
      .then((r) => r.data),

  /** Opzioni di unione (capitolato "NESSUNA UNIONE" + unioni possibili); [] se nessuna coppia. */
  getUnionOptions: (id: number): Promise<UnionOptionsResponse> =>
    api.get<UnionOptionsResponse>(`/api/box/configurations/${id}/union-options`).then((r) => r.data),

  /** Salva una risposta (pacchetto per box, oppure unione). Ritorna il menu aggiornato. */
  saveAnswer: (id: number, body: BoxAnswerRequest): Promise<BoxMenu> =>
    api.post<BoxMenu>(`/api/box/configurations/${id}/answers`, body).then((r) => r.data),

  getSummary: (id: number): Promise<BoxSummary> =>
    api.get<BoxSummary>(`/api/box/configurations/${id}/summary`).then((r) => r.data),
};
